import * as logger from 'universal-logger';
import { DALNotFoundError } from '@classpass/dal';
import { isBefore, parseISO } from 'date-fns';
import { call, put } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import SCHEDULE_CONTEXT from 'constants/schedule-context';
import { deepExtract } from 'helpers/deep';
import { setScheduleContext } from 'redux/modules/user';
import { userCreditBalance, userSubscription } from 'redux/saga/entities/bound';
import { scheduleContext } from 'redux/saga/selectors';
import { getUserId } from '../helpers';

export const selectUserCredits = state =>
  userCreditBalance.data(state, scheduleContext(state)) || {
    credits_total: 0,
    credits_remaining: 0,
  };

export function* getNextCycleDate(client, userId) {
  let subscriptionData;

  try {
    subscriptionData = yield call(fetchEntityIfNeeded, userSubscription, [client, userId]);
  } catch (error) {
    // Ignore 404 errors, since a user might not have a subscription.
    if (error instanceof DALNotFoundError) {
      return;
    }
    yield call(logger.error, 'Could not load subscription for user', error);
  }

  return deepExtract('next_cycle_subscription.cycle_start_date', subscriptionData, null);
}

export function* isDateInNextCycle(client, userId, date) {
  const nextSubscriptionCycleDate = yield call(getNextCycleDate, client, userId);

  if (!(nextSubscriptionCycleDate && date)) {
    return false;
  }

  return !isBefore(parseISO(date), parseISO(nextSubscriptionCycleDate));
}

export function* determineScheduleContext(client, scheduleDate) {
  const userId = yield call(getUserId, client);

  if (!userId) {
    return;
  }

  const isNextCycle = yield call(isDateInNextCycle, client, userId, scheduleDate);

  yield put(setScheduleContext(isNextCycle ? SCHEDULE_CONTEXT.NEXT_CYCLE : SCHEDULE_CONTEXT.CURRENT_CYCLE));
}
